import { type Html, html, View } from 'rune-ts';
import klass from './FormRow.module.scss';
import { htmlIf } from '../../../util';
import { FormRowAsteriskIcon } from '../Icon';
import { font } from '../../../typography';

export interface FormRowData {
  label: string | Html;
  content: string | Html | View | View[];
  field_right?: string | Html;
  description?: string | Html;
  required?: boolean;
  custom_klass?: string;
}

export class FormRow extends View<FormRowData> {
  override template() {
    const {
      label,
      content,
      description,
      required = false,
      custom_klass = '',
      field_right = html``,
    } = this.data;

    return html`
      <div class="${klass.form_row} ${custom_klass}">
        <div class="${klass.field} ">
          <span class="${klass.field_name} ${font('16_bold', '14_bold')}">
            ${label} ${required ? FormRowAsteriskIcon : ''}
          </span>
          <span class="${klass.field_right} ${font('12_medium')}">${field_right}</span>
        </div>
        <div class="${klass.content} ${font('16_medium', '14_medium')}">${content}</div>
        ${htmlIf(
          html`<div class="${klass.description} ${font('12_medium')}">${description}</div>`,
          !!description,
        )}
      </div>
    `;
  }

  setPropsAndRedraw(props: Partial<FormRowData>) {
    Object.assign(this.data, props);
    this.redraw();
  }
}
